(function () {
  'use strict';

  var KEY = 'eugene_partner_ref';
  var PARAM = 'partner';
  var CLEAR_PARAM = 'partner_clear';
  var TTL_DAYS = 60;
  var VALID = /^[a-z0-9][a-z0-9_-]{0,31}$/;
  var ITEM_ID = /^items\[(\d+)\]\[id\]$/;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return null;
      var saved = JSON.parse(raw);
      if (!saved || !saved.slug || !saved.expires) return null;
      if (Date.now() > saved.expires) {
        window.localStorage.removeItem(KEY);
        return null;
      }
      return saved.slug;
    } catch (e) {
      return null;
    }
  }

  function write(slug) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify({
        slug: slug,
        expires: Date.now() + TTL_DAYS * 24 * 60 * 60 * 1000
      }));
    } catch (e) { }
  }

  function fromUrl() {
    if (!window.URLSearchParams) return null;
    var raw = new URLSearchParams(window.location.search).get(PARAM);
    if (!raw) return null;
    raw = raw.toLowerCase().trim();
    return VALID.test(raw) ? raw : null;
  }

  function clearAll() {
    try { window.localStorage.removeItem(KEY); } catch (e) { }
    if (!window.fetch) return;
    fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { partner: '' } })
    }).catch(function () { });
  }

  function hidden(name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    return input;
  }

  function cartUrl(path) {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + path
      : '/' + path;
  }

  if (window.URLSearchParams && new URLSearchParams(window.location.search).get(CLEAR_PARAM)) {
    clearAll();
    return;
  }

  var fresh = fromUrl();
  if (fresh) write(fresh);
  var slug = fresh || read();
  if (!slug) return;

  if (window.fetch) {
    fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { partner: slug } })
    }).catch(function () { });
  }

  if (window.fetch) {
    document.addEventListener('us:cart-cleared', function (e) {
      var written = fetch(cartUrl('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { partner: slug } })
      }).catch(function () { });
      if (e.detail && e.detail.pending) e.detail.pending.push(written);
    });
  }

  function isAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    return (form.getAttribute('action') || '').indexOf('/cart/add') !== -1;
  }

  function stamp(form) {
    var fields = form.querySelectorAll('input[name^="items["]');
    var indexes = [];
    for (var i = 0; i < fields.length; i++) {
      var match = ITEM_ID.exec(fields[i].name);
      if (match) indexes.push(match[1]);
    }

    if (indexes.length) {
      for (var j = 0; j < indexes.length; j++) {
        var name = 'items[' + indexes[j] + '][properties][_partner]';
        if (form.querySelector('input[name="' + name + '"]')) continue;
        form.appendChild(hidden(name, slug));
      }
      return;
    }

    if (form.querySelector('input[name="properties[_partner]"]')) return;
    form.appendChild(hidden('properties[_partner]', slug));
  }

  function stampAll() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) stamp(forms[i]);
  }

  function watch() {
    stampAll();
    if (!window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        stampAll();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('submit', function (e) {
    if (isAddForm(e.target)) stamp(e.target);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
}());
